import React, {useEffect, useState} from 'react';
import {Redirect, withRouter} from 'react-router';
import {Route, Switch} from 'react-router-dom';
import {AuthRoute, withLoadedUser} from '../login/containers/Auth';
import './Admin.scss';
import Admins from './admins/containers/Admins';
import UserBrandDetails from './brand/components/UserBrandDetails';
import Brands from './brand/containers/Brand';
import Checkouts from './checkout/containers/Checkout';
import CheckoutsDetail from './checkout/containers/CheckoutDetails';
import Merchants from './merchant/containers/Merchant';
import MerchantsDetail from './merchant/containers/MerchantDetail';
import Profile from './profile/containers/Profile';
import Tags from './tag/components/TagView';
import ExportReceipts from './ticket/components/ExportReceipts';
import ListReview from './ticket/components/ListReview';
import Tickets from './ticket/containers/Ticket';
import Users from './users/containers/Users';
import CentralsListView from './centralPurchasing/components/CentralsListView';
import CentralTabsView from './centralPurchasing/components/CentralTabs/CentralTabsView';
import {ROLES} from '../common/constants';
import ProductsView from './products/components/ProductsView';
import Billing from './billing/containers/Billing';
import SubscribeView from './stripe/components/SubscribeFlow';
import AddCampaignView from './campaign/components/CreateCampaignView';
import CampaignsView from './campaign/components/CampaignsView';
import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import PopIn from '../common/components/PopIn';
import AddPaymentMethod from './stripe/components/AddPaymentMethod';
import {withTranslation} from 'react-i18next';
import BuyNotificationView from './products/components/BuyNotificationView';
import moment from 'moment';
import Dashboard from './dashboard/containers/Dashboard';

const Admin = ({t, history, currentUser, refetchCurrentUser}) => {

  const [askPaymentMethod, setAskPaymentMethod] = useState(false);
  const manageAskPaymentMethod = () => {
    // Ask payment information, if the merchant has not a valid one and if the account is created since at least 7 days
    if (
      currentUser.role === ROLES.MERCHANT &&
      !currentUser.hasValidPaymentMethod &&
      moment(currentUser.createdAt).add(7, 'days').isBefore()
    ) {
      setAskPaymentMethod(true);
    }
  };
  useEffect(() => history.listen(manageAskPaymentMethod));
  useEffect(manageAskPaymentMethod, [currentUser]);

  return (
    <div className="admin-layout">
      <Switch>
        <Route exact path="/admin/profile" component={Profile} />
        <AuthRoute roles={[ROLES.ADMIN, ROLES.MERCHANT]} exact path="/admin/dashboard" component={Dashboard} />
        <AuthRoute roles={[ROLES.ADMIN, ROLES.USER]} exact path="/admin/brands" component={Brands} />
        <AuthRoute roles={[ROLES.USER]} exact path="/admin/brand/:id" component={UserBrandDetails} />
        <AuthRoute roles={[ROLES.ADMIN]} exact path="/admin/merchants" component={Merchants} />
        <AuthRoute roles={[ROLES.ADMIN]} exact path="/admin/merchants/:id" component={MerchantsDetail} />
        <Route exact path="/admin/tickets" component={Tickets} />
        <AuthRoute roles={[ROLES.MERCHANT]} exact path="/admin/tickets/reviews" component={ListReview} />
        <AuthRoute roles={[ROLES.USER]} exact path="/admin/tickets/export" component={ExportReceipts} />
        <AuthRoute roles={[ROLES.ADMIN]} exact path="/admin/users" component={Users} />
        <AuthRoute roles={[ROLES.ADMIN]} exact path="/admin/centrals" component={CentralsListView} />
        <AuthRoute roles={[ROLES.ADMIN]} exact path="/admin/central/:id" component={CentralTabsView} />
        <AuthRoute roles={[ROLES.ADMIN]} exact path="/admin/admins" component={Admins} />
        <AuthRoute roles={[ROLES.ADMIN, ROLES.MERCHANT]} exact path="/admin/checkouts" component={Checkouts} />
        <AuthRoute roles={[ROLES.ADMIN, ROLES.MERCHANT]} exact path="/admin/checkouts/:id" component={CheckoutsDetail} />
        <AuthRoute roles={[ROLES.MERCHANT]} exact path="/admin/campaign" component={CampaignsView} />
        <AuthRoute roles={[ROLES.MERCHANT]} exact path="/admin/campaign/add" component={AddCampaignView} />
        <AuthRoute roles={[ROLES.ADMIN]} exact path="/admin/tags" component={Tags} />
        <AuthRoute exact path="/admin/billing" component={Billing} />
        <AuthRoute roles={[ROLES.ADMIN]} exact path="/admin/products/notifications" component={ProductsView} />
        <AuthRoute roles={[ROLES.MERCHANT]} exact path="/admin/products/buy/notification" component={BuyNotificationView} />
        <AuthRoute roles={[ROLES.USER, ROLES.MERCHANT, ROLES.ADMIN]} exact path="/admin/user/:userId/subscribe/:subscriptionPlanId" component={SubscribeView} />
        <Redirect from="/admin/*" to="/404" />
      </Switch>

      <PopIn title={t('paymentManagement.information')} visible={askPaymentMethod} setModalVisible={setAskPaymentMethod} size={'lg'}>
        {t('paymentManagement.paymentMethodIsRequired')}
        {askPaymentMethod && (
          <AddPaymentMethod
            userId={currentUser.id}
            onComplete={() => setAskPaymentMethod(false) && refetchCurrentUser()}
            onCancel={() => setAskPaymentMethod(false)}
          />
        )}
      </PopIn>
    </div>
  );
};

Admin.propTypes = {
  history: PropTypes.object.isRequired,
  currentUser: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    role: PropTypes.oneOf(Object.values(ROLES)).isRequired,
    hasValidPaymentMethod: PropTypes.bool.isRequired,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
  refetchCurrentUser: PropTypes.func.isRequired,
};

export default compose(
  withTranslation('stripe'),
  withRouter,
  withLoadedUser,
)(Admin);
